import React from "react";

const stats = [
  { value: "60%", label: { el: "Αύξηση αποδοτικότητας", en: "Efficiency increase" } },
  { value: "24/7", label: { el: "AI λειτουργία", en: "AI uptime" } },
  { value: "100+", label: { el: "Επιχειρήσεις εμπιστεύονται", en: "Businesses trust us" } },
  { value: "3×", label: { el: "Ταχύτερη ανάπτυξη", en: "Faster delivery" } },
];

export default function About({ t, lang = "el" }) {
  return (
    <section
      id="about"
      style={{
        padding: "6rem 2rem",
        background: "var(--bg-primary)",
        position: "relative",
        overflow: "hidden"
      }}
    >
      {/* Glow accent */}
      <div style={{
        position: "absolute", bottom: 0, right: "10%",
        width: "400px", height: "400px",
        background: "radial-gradient(circle, rgba(79,142,247,0.1) 0%, transparent 70%)",
        pointerEvents: "none"
      }} />

      <div style={{ maxWidth: "1000px", margin: "0 auto", position: "relative" }}>
        <p style={{
          textAlign: "center",
          fontSize: "0.75rem",
          fontWeight: "600",
          letterSpacing: "3px",
          textTransform: "uppercase",
          color: "var(--accent-blue)",
          marginBottom: "0.8rem"
        }}>
          {t.about}
        </p>

        <h2 style={{
          textAlign: "center",
          fontSize: "2.2rem",
          fontWeight: "800",
          color: "var(--text-primary)",
          marginBottom: "1.2rem",
          letterSpacing: "-0.03em"
        }}>
          {t.about_title}
        </h2>

        <p style={{
          textAlign: "center",
          maxWidth: "680px",
          margin: "0 auto 4rem",
          color: "var(--text-secondary)",
          fontSize: "1.05rem",
          lineHeight: "1.75"
        }}>
          {t.about_text}
        </p>

        {/* Stats grid */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
          gap: "1.5rem"
        }}>
          {stats.map((s, i) => (
            <div key={i} style={{
              background: "var(--bg-card)",
              border: "1px solid var(--border)",
              borderRadius: "16px",
              padding: "1.75rem 1.5rem",
              textAlign: "center",
              transition: "border-color 0.2s, background 0.2s"
            }}
            onMouseEnter={e => e.currentTarget.style.borderColor = "var(--border-hover)"}
            onMouseLeave={e => e.currentTarget.style.borderColor = "var(--border)"}
            >
              <div style={{
                fontSize: "2.4rem",
                fontWeight: "800",
                letterSpacing: "-0.04em",
                background: "linear-gradient(135deg, #fff 0%, #c4b5fd 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                marginBottom: "0.4rem"
              }}>
                {s.value}
              </div>
              <div style={{ fontSize: "0.85rem", color: "var(--text-secondary)", fontWeight: "500" }}>
                {s.label[lang] || s.label.el}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
